import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import WifiOff from '@mui/icons-material/WifiOff';
import Chip, { ChipProps } from '@mui/material/Chip';

import { IMAGE_OVERLAY_Z_INDEX } from '../../config';
import type { AnalysisResultVariant } from '../../types';

interface Props {
  variant: AnalysisResultVariant | 'offline';
  obfuscateAi?: boolean;
}

type ResultContent = {
  label: string;
  color: ChipProps['color'];
  icon: ChipProps['icon'];
};

const getResultContent = (variant: Props['variant'], obfuscateAi = false): ResultContent => {
  const baseContent: Record<Props['variant'], ResultContent> = {
    'ai-reject': {
      color: 'error',
      icon: <ErrorOutlineOutlined />,
      label: obfuscateAi ? 'Rejected' : 'AI rejected',
    },
    'ai-success': {
      color: 'success',
      icon: <CheckCircleOutlined />,
      label: obfuscateAi ? 'Accepted' : 'AI accepted',
    },
    no: {
      color: 'error',
      icon: <ErrorOutlineOutlined />,
      label: 'No',
    },
    offline: {
      color: 'info',
      icon: <WifiOff />,
      label: 'Offline',
    },
    'quality-accept': {
      color: 'success',
      icon: <CheckCircleOutlined />,
      label: 'Quality accepted',
    },
    'quality-reject': {
      color: 'error',
      icon: <ErrorOutlineOutlined />,
      label: 'Quality rejected',
    },
    warning: {
      color: 'warning',
      icon: <WarningAmberOutlined />,
      label: 'Warning',
    },
    yes: {
      color: 'success',
      icon: <CheckCircleOutlined />,
      label: 'Yes',
    },
  };

  return baseContent[variant];
};

export const AnalysisResultChip = ({ variant, obfuscateAi = false }: Props) => {
  const content = getResultContent(variant, obfuscateAi);

  return (
    <Chip
      data-testid={variant + '-chip'}
      label={content.label}
      color={content.color}
      icon={content.icon}
      size="small"
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        zIndex: IMAGE_OVERLAY_Z_INDEX + 1,
      }}
    />
  );
};
